module.exports = __webpack_public_path__ + "/public/images/7f31a203b54006f722a199ddf892c0e1.png";